import { Directive, ElementRef, Input, Renderer, OnChanges} from '@angular/core';
import * as moment from 'moment'

@Directive({
    selector: '[overdueSchedule]'
})
/**
 * this directive add class 'overdue'to  <th> element
 */
export class OverdueScheduleDirective implements OnChanges {

    @Input() overdueTime: any;

    constructor(public el: ElementRef, public renderer: Renderer) {
    }

    ngOnChanges() {
        let rowTime = moment.utc(this.overdueTime);
        let now = moment.utc();

        if(rowTime<now){
            this.el.nativeElement.className = 'overdue';
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/views/leads/leads.directives.ts